import React, {FunctionComponent, useContext} from 'react';
import { RouteProps, RouteComponentProps, Route, Redirect } from 'react-router-dom';
import {RootStoreContext} from "../../stores/rootStore";
import {observer} from "mobx-react-lite";

interface IProps extends RouteProps {
    component: React.ComponentType<RouteComponentProps<any>>
}

const TrafficManagerAndEmployeeRoute: FunctionComponent<IProps> = ({component: Component, ...rest}) => {
    const rootStore = useContext(RootStoreContext)
    const { isLoggedIn, isTrafficManager, isEmployee } = rootStore.userStore
        
  return (
      <Route 
          { ...rest }
          render={(props) => isLoggedIn && (isTrafficManager || isEmployee) ? <Component { ...props } /> : <Redirect to='/' />}
      />
  )
}

export default observer(TrafficManagerAndEmployeeRoute)
